import * as AllButtons from './Buttons/index';
import styled from 'styled-components';

export default function Buttons({ pageId, isPreview, buttons, onClick }) {
	const renderButtons = buttons.map((b, i) => {
		if (!b.type.length) {
			b.type = 'Button';
		}

		if (!AllButtons[b.type]) {
			return null;
		}

		const TagName = AllButtons[b.type];
		return <TagName onClick={onClick} key={i} pageId={pageId} {...b} />;
	});

	return (
		<StyledButtons isPreview={isPreview} id="slp-Buttons">
			{renderButtons}
		</StyledButtons>
	);
}

const StyledButtons = styled.div`
	position: ${(props) => (props.isPreview ? 'static' : 'relative')};
	z-index: 1;
`;
